import * as wx from '@wecom/jssdk';
import app from 'flarum/forum/app';

import { loadVConsole } from '../common/utils';

// @ts-ignore
app.wecomSDK = wx;

export default function setupSDK(corpId: string, agentId: string) {
  // 初始化时获取不到一些参数，去要在app.data.resources里解析
  // 具体看vendor/flarum/core/js/src/common/Application.tsx boot函数内
  // 先初始化所有扩展后再解析app.data数据，这里先放在setTimeout里获取
  setTimeout(() => {
    if (app.forum.attribute('debug')) {
      loadVConsole();
    }
  }, 0);

  wx.register({
    corpId,
    agentId,
    jsApiList: ['shareAppMessage', 'openEnterpriseChat'],
    getConfigSignature(url) {
      const timestamp = Math.floor(Date.now() / 1000);
      const nonceStr = 'wecomSDK';
      return app
        .request({
          method: 'GET',
          url: '/adapter-api/wecom/signature',
          params: {
            timestamp,
            nonceStr,
            url,
          },
        })
        .then((result: any) => ({
          timestamp,
          nonceStr,
          signature: result.data,
        }));
    },
    onConfigComplete(e) {
      console.log(e);
    },
    onConfigFail(e) {
      console.log(e);
    },
  });
}
